export default "__VITE_ASSET__CoT52iBk__"